import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const DeleteUserModal = ({ isOpen, user, isDeleting, onCancel, onConfirm }) => (
  <Modal isOpen={isOpen} toggle={onCancel} className="modal-md users-modal">
    <ModalHeader toggle={onCancel}>
      <span className="users-modal__title">Delete User</span>
    </ModalHeader>
    <ModalBody className="users-modal__body">
      <p className="users-modal__copy">
        This will remove <strong>{user && user.name ? user.name : "this user"}</strong>.
      </p>
      <p className="users-modal__helper">
        Continue only if this account should no longer be available in the backoffice.
      </p>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button color="danger" onClick={onConfirm} disabled={isDeleting}>
        Delete
      </Button>
    </ModalFooter>
  </Modal>
);

export default DeleteUserModal;
